/** The template catalog: frozen GameSpecs the generation process starts from. */
import { SEWER_1983_TEMPLATE } from './bumpArcadeMario.js';
import { STOLEN_WINGS_TEMPLATE } from './formationShooterWings.js';
import { BOUNTY_BOB_TEMPLATE } from './minePlatformerBob.js';
import { GLOW_RUSH_TEMPLATE, SCOOP_RUSH_TEMPLATE } from './serviceCounter.js';
import { BLUE_MAX_TEMPLATE } from './strikeFlightBlueMax.js';
import { TRANQUILITY_NINE_TEMPLATE } from './landerTranquilityNine.js';
import { SKI_2600_TEMPLATE } from './downhillSki2600.js';
import { SEWER_DUEL_TEMPLATE } from './sewerDuel.js';
import { ARENA_TANKS_TEMPLATE } from './arenaTanks.js';
import type { TemplateV1 } from './template.js';

export const COMPOSE_TEMPLATES: readonly TemplateV1[] = Object.freeze([SEWER_1983_TEMPLATE, STOLEN_WINGS_TEMPLATE, BOUNTY_BOB_TEMPLATE,
  SCOOP_RUSH_TEMPLATE, GLOW_RUSH_TEMPLATE, BLUE_MAX_TEMPLATE, TRANQUILITY_NINE_TEMPLATE, SKI_2600_TEMPLATE, SEWER_DUEL_TEMPLATE, ARENA_TANKS_TEMPLATE]);

export * from './template.js';
export * from './verbProofs.js';
export * from './structure.js';
export * from './variants.js';
export * from './generated.js';
export * from './textFacts.js';
export { SEWER_1983_SPEC, SEWER_1983_TEMPLATE, sewerPhaseTable } from './bumpArcadeMario.js';
export { STOLEN_WINGS_SPEC, STOLEN_WINGS_TEMPLATE, wingsWaveTable } from './formationShooterWings.js';
export { BOUNTY_BOB_SPEC, BOUNTY_BOB_TEMPLATE, MINE_BAYS, MINE_BAY_SEED, mineBay, mineBayPhases, type MineBay } from './minePlatformerBob.js';
export { GLOW_RUSH_SPEC, GLOW_RUSH_TEMPLATE, SCOOP_RUSH_SPEC, SCOOP_RUSH_TEMPLATE, scoopQueue } from './serviceCounter.js';
export { BLUE_MAX_SPEC, BLUE_MAX_TEMPLATE } from './strikeFlightBlueMax.js';
export { TRANQUILITY_NINE_SPEC, TRANQUILITY_NINE_TEMPLATE } from './landerTranquilityNine.js';
export { SKI_2600_SPEC, SKI_2600_TEMPLATE } from './downhillSki2600.js';
export { SEWER_DUEL_TEMPLATE } from './sewerDuel.js';
export { ARENA_TANKS_SPEC, ARENA_TANKS_TEMPLATE } from './arenaTanks.js';
